import { render, staticRenderFns } from "./ProjectStatusSelect.vue?vue&type=template&id=2e16e0e4&"
import script from "./ProjectStatusSelect.vue?vue&type=script&lang=js&"
export * from "./ProjectStatusSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports